import { useState, useCallback } from 'react';
import { opportunitiesDefaultStates } from '../OpportunitiesDefaultStates';

export const useOpportunitiesState = () => {
  //check subdomain if jobs or talent
  const isJobs = useCallback(() => {
    return window.location.hostname.split('.')[0] === 'jobs';
  }, []);

  const [hideFilters, setHideFiltersState] = useState(opportunitiesDefaultStates.hideFilters);
  const [shrink, setShrinkLocal] = useState(opportunitiesDefaultStates.shrink);
  const setHideFilters = useCallback(() => {
    setHideFiltersState((prevHideFilters) => !prevHideFilters);
  }, []);

  const setShrink = useCallback(
    (shrink: boolean) => {
      if (isJobs()) setShrinkLocal(shrink);
    },
    [isJobs],
  );
  return {
    shrink,
    setShrink,
    hideFilters,
    setHideFilters,
    isJobs,
  };
};
